import { ThemakiezerApiClient } from "../../../../Shared/backendApi/collection.themakiezer.generated";
export const fetchEmbed = (embedId)=>()=>httpResult(()=>client.getEmbed(embedId));
const client = new ThemakiezerApiClient(window.location.origin);
const httpResult = async (promise)=>{
    try {
        return {
            kind: 'result',
            value: await promise(),
            status: 200
        };
    } catch (error) {
        console.error(error);
        return {
            kind: 'failed',
            status: 500
        };
    }
};
